/**
 * Backend error strings the console recognises.
 *
 * These are matched rather than read from an error code because sdapi does not yet
 * put a code in the GraphQL `extensions` block. Each literal must stay byte-identical
 * to the constant in the owning service — reword one side and the console silently
 * falls back to a generic message, which is why both sides pin it in a test.
 */

/** phoenix-jobs: PIPELINE_EXECUTION_ALREADY_RUNNING_MESSAGE in trigger_pipeline_execution.py */
export const PIPELINE_EXECUTION_ALREADY_RUNNING_ERROR =
  'There is already a running execution for this pipeline';

const readErrorMessage = (error: unknown): string => {
  const message =
    error instanceof Error
      ? error.message
      : ((error as { message?: unknown })?.message ?? '');

  return typeof message === 'string' ? message : '';
};

export const isPipelineExecutionAlreadyRunningError = (
  error: unknown,
): boolean =>
  readErrorMessage(error).includes(PIPELINE_EXECUTION_ALREADY_RUNNING_ERROR);

/**
 * back-office: FeatureFlagStillAssignedError, raised in
 * services/super_tenant/delete_feature_flag.py with the tenant count appended,
 * so only the invariant part of the sentence is matched.
 */
export const FEATURE_FLAG_STILL_ASSIGNED_ERROR = 'is still assigned to';

export const isFeatureFlagStillAssignedError = (error: unknown): boolean => {
  const message = readErrorMessage(error);

  return message.includes(FEATURE_FLAG_STILL_ASSIGNED_ERROR);
};
